import { Phone, Mail, MapPin } from "lucide-react";
import { COMPANY, SERVICE_AREAS, SERVICES } from "@/data/siteContent";
import Logo from "@/components/brand/Logo";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A2513] text-white pb-28 md:pb-16"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12 pt-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3">
              <Logo size={48} contained={false} data-testid="footer-logo" />
              <span className="font-display text-xl font-semibold">
                Ecomold Clean
              </span>
            </div>
            <p className="mt-4 text-sm text-white/60 leading-relaxed max-w-sm">
              Licensed, insured mold inspection and remediation for Toronto and
              the GTA. Careful work, honest pricing, verified results.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-sm font-semibold uppercase tracking-wider text-white/80">
              Services
            </div>
            <ul className="mt-4 space-y-2 text-sm text-white/60">
              {SERVICES.map((s) => (
                <li key={s.key}>
                  <a
                    href="#services"
                    className="hover:text-white transition-colors"
                    data-testid={`footer-service-${s.key}`}
                  >
                    {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-sm font-semibold uppercase tracking-wider text-white/80">
              Service Areas
            </div>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2 text-sm text-white/60">
              {SERVICE_AREAS.slice(0, 10).map((a) => (
                <li key={a}>{a}</li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-sm font-semibold uppercase tracking-wider text-white/80">
              Contact
            </div>
            <ul className="mt-4 space-y-3 text-sm text-white/70">
              <li>
                <a
                  href={COMPANY.phoneHref}
                  className="flex items-center gap-2 hover:text-white transition-colors"
                  data-testid="footer-phone"
                >
                  <Phone className="h-4 w-4" /> {COMPANY.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${COMPANY.email}`}
                  className="flex items-start gap-2 hover:text-white transition-colors break-all"
                  data-testid="footer-email"
                >
                  <Mail className="h-4 w-4 mt-0.5 shrink-0" /> {COMPANY.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 mt-0.5 shrink-0" />{" "}
                {COMPANY.location}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/50">
          <div>
            © {year} Ecomold Clean. All rights reserved.
          </div>
          <div>Licensed · Insured · GTA-wide service</div>
        </div>
      </div>
    </footer>
  );
}
